<template>
  <div
    :class="['timeline-item', sizeClass]"
    v-bind="$attrs"
  >
    <div class="timeline-icon">
      <slot name="icon" />
    </div>
    <div class="timeline-content">
      <slot name="content">
        <p class="timeline-title">
          <slot name="title">{{ title }}</slot>
        </p>
        <div class="timeline-content-inner">
          <slot name="content-inner">
            <p class="timeline-subtitle">{{ subtitle }}</p>
            <p class="timeline-description">{{ description }}</p>
          </slot>
        </div>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue';

defineProps({
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['lg', 'md', 'sm'].includes(value),
  },
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});

const { size: timelineSize } = inject('timeline');

const sizeClass = computed(() => {
  return {
    lg: 'timeline-item-lg',
    md: 'timeline-item-md',
    sm: 'timeline-item-sm',
  }[timelineSize];
});
</script>

<style>
@reference '@/assets/main.css';

.timeline-item {
  @apply relative flex gap-3;

  &:not(:last-child) {
    &:before,
    &:after {
      @apply content-[''] absolute left-[calc(var(--connector-offset))] top-7 bottom-1 w-0.5 rounded-sm;
    }
  }

  &:last-child {
    & .timeline-content {
      @apply pb-0;
    }
  }

  &:before {
    @apply bg-gray-200;
  }

  &[data-finished='true'] {
    &:after {
      @apply bg-brand-600;
    }
  }
}

.timeline-icon {
  @apply relative z-10;
}

.timeline-content {
  @apply w-full pt-1.25 pb-6;
}

.timeline-title {
  @apply font-semibold text-gray-700;
}

.timeline-content-inner {
  @apply text-gray-500;
}

.timeline-subtitle {
  @apply text-gray-500;
}

.timeline-description {
  @apply py-1 text-gray-500;
}

.timeline-item-sm {
  & .timeline-content {
    @apply pt-0.5;
  }
}

.timeline-item-lg {
  & .timeline-content {
    @apply pt-2.25;
  }
}
</style>
